import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { USER_TIERS } from '../contexts/AuthContext';
import AIStoryboard from '../features/ai/AIStoryboard';
import AIContentTools from '../features/ai/AIContentTools';
import AIVideoCreator from '../features/ai/AIVideoCreator';
import AudioAnalysis from '../features/ai/AudioAnalysis';
import ContentSummarize from '../features/ai/ContentSummarize';
import AuthRedirect from '../shared/AuthRedirect';
import ProtectedRoute from '../shared/ProtectedRoute';
import SubMenu from '../shared/SubMenu';
import { AI_MENU_ITEMS } from '../config/menuConfig';

const AIRouter = () => {
  return (
    <>
      <SubMenu items={AI_MENU_ITEMS} />
      <Routes>
        <Route path="/" element={
          <ProtectedRoute requiredTiers={[USER_TIERS.SUBSCRIBER, USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
            <AIContentTools />
          </ProtectedRoute>
        } />
        <Route
          path="/storyboard"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.SUBSCRIBER, USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <AIStoryboard />
            </ProtectedRoute>
          }
        />
        {/* 기존 /content-tools URL은 홈으로 리다이렉트 */}
        <Route path="/content-tools" element={<Navigate to="/" replace />} />
        <Route
          path="/video-creator"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.SUBSCRIBER, USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <AIVideoCreator />
            </ProtectedRoute>
          }
        />
        <Route
          path="/audio-analysis"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.SUBSCRIBER, USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <AudioAnalysis />
            </ProtectedRoute>
          }
        />
        <Route
          path="/content-summarize"
          element={
            <ProtectedRoute requiredTiers={[USER_TIERS.SUBSCRIBER, USER_TIERS.FAMILY, USER_TIERS.ADMIN]}>
              <ContentSummarize />
            </ProtectedRoute>
          }
        />
        {/* 인증 관련 경로는 auth.ilouli.com으로 리다이렉트 */}
        <Route path="/profile" element={<AuthRedirect path="/profile" />} />
        <Route path="/login" element={<AuthRedirect path="/login" />} />
      </Routes>
    </>
  );
};

export default AIRouter;
